import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";




// 2. Component ke andar, useState ke saath:


const Sidebar = ({ onLogout }) => {
  const [openMenu, setOpenMenu] = useState(null);
  const [loginId, setLoginId] = useState("");
  const location = useLocation();
  const [allowedModules, setAllowedModules] = useState([]);
 

useEffect(() => {
    const storedLoginId = sessionStorage.getItem("loginId") || "";
    setLoginId(storedLoginId);

    const storedModules = sessionStorage.getItem("allowedModules");
    if (storedModules) {
      try {
        const parsedModules = JSON.parse(storedModules);
        
        // ✅ FIX: Load karte waqt hi sabko UPPERCASE bana lo
        // Taaki "Pharmacy", "pharmacy", "PHARMACY" sab match ho jayein
        if (Array.isArray(parsedModules)) {
          const normalizedModules = parsedModules.map(m => String(m).toUpperCase());
          setAllowedModules(normalizedModules);
          console.log("Allowed Modules (Normalized):", normalizedModules); // Debugging
        }
      } catch (e) {
        console.error("Error parsing modules", e);
        setAllowedModules([]);
      }
    }
  }, []);

  const hasAccess = (requiredModule) => {
    // Agar allowedModules load nahi hua hai toh false return karo
    if (!allowedModules || allowedModules.length === 0) return false;

    // 1. Super Admin Check
    if (allowedModules.includes("HMS") || allowedModules.includes("ADMIN")) {
      return true;
    }

    // Safety check: Agar requiredModule null/undefined hai
    if (!requiredModule) return false;

    // 2. Array Check (e.g. ["OPD", "DOCTOR"])
    if (Array.isArray(requiredModule)) {
       return requiredModule.some(m => m && allowedModules.includes(String(m).toUpperCase()));
    }

    // 3. Single String Check (e.g. "PHARMACY")
    return allowedModules.includes(String(requiredModule).toUpperCase());
  };

  const toggleMenu = (menu) => setOpenMenu((prev) => (prev === menu ? null : menu));
  const menuClass = (menu) => (openMenu === menu ? "d-block" : "d-none");
  const isActive = (path) => location.pathname === path;

  return (
    <div className="sidebar-container h-100 d-flex flex-column bg-gradient-primary">
      {/* User Profile Section */}
      <div className="sidebar-header text-center py-3 border-bottom border-light border-opacity-25">
        <div className="user-avatar-wrapper mb-2">
          <div className="user-avatar mx-auto">
            <i className="bi bi-person-circle text-white"></i>
            <div className="status-dot"></div>
          </div>
        </div>
        <h6 className="text-white mb-0 fw-bold">{loginId || "Admin"}</h6>
        <small className="text-white-50 d-flex align-items-center justify-content-center gap-1">
          <i className="bi bi-shield-check"></i>
          Hospital Management
        </small>
      </div>

      {/* Scrollable Menu Section */}
      <div className="sidebar-menu flex-grow-1 p-3">
        {/* Dashboard */}
        <Link
          to="/dashboard"
          className={`sidebar-link ${isActive("/dashboard") ? "active" : ""}`}
        >
          <div className="link-icon-box">
            <i className="bi bi-speedometer2 sidebar-icon"></i>
          </div>
          <span>Dashboard</span>
        </Link>
        
          {/* <Link
          to="/AIChatPage"
          className={`sidebar-link ${isActive("/AIChatPage") ? "active" : ""}`}
        >
          <div className="link-icon-box">
            <i className="bi bi-speedometer2 sidebar-icon"></i>
          </div>
          <span>AI Assistant</span>
        </Link> */}

  


      {/* {hasAccess("HMS") && (
       
        <div className="sidebar-section">
          <button
            className={`sidebar-dropdown-btn ${openMenu === "master" ? "active" : ""}`}
            onClick={() => toggleMenu("master")}
          >
            <span className="d-flex align-items-center">
              <div className="link-icon-box">
                <i className="bi bi-gear-fill sidebar-icon"></i>
              </div>
              <span>Master</span>
            </span>
            <i className={`bi ${openMenu === "master" ? "bi-chevron-up" : "bi-chevron-down"}`}></i>
          </button>
          <div className={`sidebar-submenu ${menuClass("master")}`}>
            <Link to="/user/create" className={`sidebar-sublink ${isActive("/user/create") ? "active" : ""}`}>
              <i className="bi bi-person-plus"></i>
              User Creation
            </Link>
            <Link to="/user/Role/Creation" className={`sidebar-sublink ${isActive("/user/Role/Creation") ? "active" : ""}`}>
              <i className="bi bi-shield-check"></i>
              Roles Creation
            </Link>
            <Link to="ChargeMaster" className={`sidebar-sublink ${isActive("ChargeMaster") ? "active" : ""}`}>
              <i className="bi bi-shield-check"></i>
              ChargeMaster
            </Link>
            <Link to="/Room/Form" className={`sidebar-sublink ${isActive("/Room/Form") ? "active" : ""}`}>
              <i className="bi bi-door-open"></i>
              Room Form
            </Link>
            <Link to="/DepartmentForm" className={`sidebar-sublink ${isActive("/DepartmentForm") ? "active" : ""}`}>
              <i className="bi bi-building"></i>
              Department Form
            </Link>
            <Link to="/EmployeeForm" className={`sidebar-sublink ${isActive("/EmployeeForm") ? "active" : ""}`}>
              <i className="bi bi-person-badge"></i>
              Employee Form
            </Link>
            <Link to="/DiscountAuthorityForm" className={`sidebar-sublink ${isActive("/DiscountAuthorityForm") ? "active" : ""}`}>
              <i className="bi bi-percent"></i>
              Discount Authority
            </Link>

 <Link to="/PackagesMaster" className={`sidebar-sublink ${isActive("/PackagesMaster") ? "active" : ""}`}>
              <i className="bi bi-building-add"></i>
              Packages Master
            </Link>
            
            <Link to="/PharmaCompanyForm" className={`sidebar-sublink ${isActive("/PharmaCompanyForm") ? "active" : ""}`}>
              <i className="bi bi-building-add"></i>
              Pharma Company
            </Link>
              <Link to="/FinancialLedger" className={`sidebar-sublink ${isActive("/FinancialLedger") ? "active" : ""}`}>
              <i className="bi bi-building-add"></i>
              Financial ledger
            </Link>
          
           
           
          </div>
        </div>

    )} */}


            {/* =========================================
            CENTRAL MASTER MODE BUTTON
            ========================================= */}
        {hasAccess("HMS") && (
          <Link
            className={`sidebar-link ${location.pathname.includes("/master") ? "active" : ""}`}
           to="/master/user/create" 
           >
            <div className="link-icon-box" style={{ background: '#8b5cf6' }}> {/* Purple Color */}
              <i className="bi bi-gear-fill sidebar-icon text-white"></i>
            </div>
            <span>Central Master</span>
          </Link>
        )}




           {/* =========================================
            NEW CLINICAL/RECEPTION ERP BUTTON
            ========================================= */}
        {hasAccess(["OPD", "IPD", "HMS"]) && (
          <Link
            to="/clinical/register" 
            className={`sidebar-link ${location.pathname.includes("/clinical") ? "active" : ""}`}
          >
            <div className="link-icon-box" style={{ background: '#3b82f6' }}> {/* Blue color for clinical */}
              <i className="bi bi-hospital sidebar-icon text-white"></i>
            </div>
            <span>Reception </span>
          </Link>
        )}


      {hasAccess(["Billing", "HMS"]) && (
          <Link
            to="/billing/form" 
            className={`sidebar-link ${location.pathname.includes("/billing") ? "active" : ""}`}
          >
            <div className="link-icon-box" style={{ background: '#f59e0b' }}>
              <i className="bi bi-receipt-cutoff sidebar-icon text-white"></i>
            </div>
            <span>Billing </span>
          </Link>
        )}



        {/* Medicine Section */}

        {/* NEW PHARMACY ERP BUTTON */}
        {hasAccess("Pharmacy") && (
          <Link
            to="/pharmacy/sale" // Ya jo bhi default page rakhna ho
            className={`sidebar-link ${location.pathname.includes("/pharmacy") ? "active" : ""}`}
          >
            <div className="link-icon-box" style={{ background: '#0d9488' }}>
              <i className="bi bi-capsule-pill sidebar-icon text-white"></i>
            </div>
            <span>Pharmacy (ERP Mode)</span>
          </Link>
        )}




    {/* =========================================
    ADMIN REPORTS (ONLY FOR HMS)
========================================= */}
   {hasAccess("HMS") && (
  <Link
    to="/admin-reports/billing-summary" 
    className={`sidebar-link ${location.pathname.includes("/admin-reports") ? "active" : ""}`}
  >
    <div className="link-icon-box" style={{ background: '#8b5cf6' }}>
      <i className="bi bi-bar-chart-fill sidebar-icon text-white"></i>
    </div>
    <span>Admin Reports Center</span>
  </Link>
)}

        {/* Patient Registration */}

        {/* {hasAccess([ "OPD","IPD"]) && (
        <Link
          to="/opd/register"
          className={`sidebar-link ${isActive("/opd/register") ? "active" : ""}`}
        >
          <div className="link-icon-box">
            <i className="bi bi-person-plus-fill sidebar-icon"></i>
          </div>
          <span>Patient Registration</span>
        </Link>




        )}
         */}
      

        {/* =========================================
            PRESCRIPTION SECTION 
            ========================================= */}
        {hasAccess(["HMS", "DOCTOR"]) && (
          <div className="sidebar-section">
            <button
              className={`sidebar-dropdown-btn ${openMenu === "prescription" ? "active" : ""}`}
              onClick={() => toggleMenu("prescription")}
            >
              <span className="d-flex align-items-center">
                <div className="link-icon-box">
                  <i className="bi bi-capsule sidebar-icon"></i>
                </div>
                <span>Prescription</span>
              </span>
              <i className={`bi ${openMenu === "prescription" ? "bi-chevron-up" : "bi-chevron-down"}`}></i>
            </button>
            <div className={`sidebar-submenu ${menuClass("prescription")}`}>
              
              {/* Create Prescription */}
              <Link to="/PrescriptionCreate" className={`sidebar-sublink ${isActive("/PrescriptionCreate") ? "active" : ""}`}>
                <i className="bi bi-pencil-square"></i>
                New Prescription
              </Link>

              {/* Prescription History */}
              <Link to="/PrescriptionHistory" className={`sidebar-sublink ${isActive("/PrescriptionHistory") ? "active" : ""}`}>
                <i className="bi bi-clock-history"></i>
                History
              </Link>

            </div>
          </div>
        )}

{/* =========================================
            USG SECTION 
            ========================================= */}
        {hasAccess(["HMS", "DOCTOR", "LABORATORY"]) && (
          <div className="sidebar-section">
            <button
              className={`sidebar-dropdown-btn ${openMenu === "usg" ? "active" : ""}`}
              onClick={() => toggleMenu("usg")}
            >
              <span className="d-flex align-items-center">
                <div className="link-icon-box">
                  <i className="bi bi-file-medical-fill sidebar-icon"></i>
                </div>
                <span>USG / Lab</span>
              </span>
              <i className={`bi ${openMenu === "usg" ? "bi-chevron-up" : "bi-chevron-down"}`}></i>
            </button>
            <div className={`sidebar-submenu ${menuClass("usg")}`}>


              {/* USG Header Config - Only for HMS */}
              {hasAccess("HMS") && (
                <Link to="/UsgReportHeaderConfig" className={`sidebar-sublink ${isActive("/UsgReportHeaderConfig") ? "active" : ""}`}>
                  <i className="bi bi-file-earmark-image"></i>
                  USG Receipt Header 
                </Link>
              )}
              
              {/* USG Master - Only for HMS */}
              {hasAccess("HMS") && (
                <Link to="/UsgMasterPage" className={`sidebar-sublink ${isActive("/UsgMasterPage") ? "active" : ""}`}>
                  <i className="bi bi-journal-plus"></i>
                  USG Master
                </Link>
              )}

              {/* USG Report - For HMS, DOCTOR, LABORATORY */}
              <Link to="/UsgReportPage" className={`sidebar-sublink ${isActive("/UsgReportPage") ? "active" : ""}`}>
                <i className="bi bi-pencil-square"></i>
                New Report
              </Link>

              {/* USG History - For HMS, DOCTOR, LABORATORY */}
              <Link to="/UsgReportHistory" className={`sidebar-sublink ${isActive("/UsgReportHistory") ? "active" : ""}`}>
                <i className="bi bi-clock-history"></i>
                Report History
              </Link>

            </div>
          </div>
        )}


   {/* OPD Section */}
        {/* {hasAccess("OPD") && (
     
        <div className="sidebar-section">
          <button
            className={`sidebar-dropdown-btn ${openMenu === "opd" ? "active" : ""}`}
            onClick={() => toggleMenu("opd")}
          >
            <span className="d-flex align-items-center">
              <div className="link-icon-box">
                <i className="bi bi-calendar-check-fill sidebar-icon"></i>
              </div>
              <span>OPD</span>
            </span>
            <i className={`bi ${openMenu === "opd" ? "bi-chevron-up" : "bi-chevron-down"}`}></i>
          </button>
          <div className={`sidebar-submenu ${menuClass("opd")}`}>
            <Link to="/opd/list" className={`sidebar-sublink ${isActive("/opd/list") ? "active" : ""}`}>
              <i className="bi bi-list-ul"></i>
              OPD List
            </Link>
          </div>
        </div>
        )} */}
        {/* IPD Section */}

        {/* {hasAccess("IPD") && (
        <div className="sidebar-section">
          <button
            className={`sidebar-dropdown-btn ${openMenu === "ipd" ? "active" : ""}`}
            onClick={() => toggleMenu("ipd")}
          >
            <span className="d-flex align-items-center">
              <div className="link-icon-box">
                <i className="bi bi-hospital-fill sidebar-icon"></i>
              </div>
              <span>IPD</span>
            </span>
            <i className={`bi ${openMenu === "ipd" ? "bi-chevron-up" : "bi-chevron-down"}`}></i>
          </button>
          <div className={`sidebar-submenu ${menuClass("ipd")}`}>
            <Link to="/IpdList" className={`sidebar-sublink ${isActive("/IpdList") ? "active" : ""}`}>
              <i className="bi bi-list-ul"></i>
              IPD List
            </Link>
            <Link to="/IpdAdvance" className={`sidebar-sublink ${isActive("/IpdAdvance") ? "active" : ""}`}>
              <i className="bi bi-cash-coin"></i>
              Advance Payment
            </Link>
            <Link to="/IpdServiceDetails" className={`sidebar-sublink ${isActive("/IpdServiceDetails") ? "active" : ""}`}>
              <i className="bi bi-file-medical"></i>
              Service Details
            </Link>
            <Link to="/Room/Booking/Form" className={`sidebar-sublink ${isActive("/Room/Booking/Form") ? "active" : ""}`}>
              <i className="bi bi-calendar-check"></i>
              Room Booking
            </Link>
            <Link to="/DischargeBill" className={`sidebar-sublink ${isActive("/DischargeBill") ? "active" : ""}`}>
              <i className="bi bi-receipt"></i>
              Discharge Bill
            </Link>
            <Link to="/DischargeList" className={`sidebar-sublink ${isActive("/DischargeList") ? "active" : ""}`}>
              <i className="bi bi-list-check"></i>
              Discharge List
            </Link>
               <Link to="/IpdReport" className={`sidebar-sublink ${isActive("/IpdReport") ? "active" : ""}`}>
              <i className="bi bi-building-add"></i>
              Ipd Report
            </Link>

          </div>
        </div>
        )} */}

          {/* Billing Section */}
        {/* {hasAccess("Billing") && (
      
        <div className="sidebar-section">
          <button
            className={`sidebar-dropdown-btn ${openMenu === "billing" ? "active" : ""}`}
            onClick={() => toggleMenu("billing")}
          >
            <span className="d-flex align-items-center">
              <div className="link-icon-box">
                <i className="bi bi-receipt-cutoff sidebar-icon"></i>
              </div>
              <span>Billing</span>
            </span>
            <i className={`bi ${openMenu === "billing" ? "bi-chevron-up" : "bi-chevron-down"}`}></i>
          </button>
          <div className={`sidebar-submenu ${menuClass("billing")}`}>
            <Link to="/BillingForm" className={`sidebar-sublink ${isActive("/BillingForm") ? "active" : ""}`}>
              <i className="bi bi-file-earmark-plus"></i>
              Billing Form
            </Link>
            <Link to="/BillList" className={`sidebar-sublink ${isActive("/BillList") ? "active" : ""}`}>
              <i className="bi bi-list-ul"></i>
              Billing List
            </Link>
            <Link to="/BillingPayment" className={`sidebar-sublink ${isActive("/BillingPayment") ? "active" : ""}`}>
              <i className="bi bi-credit-card"></i>
              Billing Payment
            </Link>
            <Link to="/Report" className={`sidebar-sublink ${isActive("/Report") ? "active" : ""}`}>
              <i className="bi bi-graph-up"></i>
              Report
            </Link>
          </div>
        </div>

)} */}


   {hasAccess( "Accounts") && (
        <div className="sidebar-section">
          <button
            className={`sidebar-dropdown-btn ${openMenu === "accounts" ? "active" : ""}`}
            onClick={() => toggleMenu("accounts")}
          >
            <span className="d-flex align-items-center">
              <div className="link-icon-box">
                <i className="bi bi-wallet2 sidebar-icon"></i>
              </div>
              <span>Accounts</span>
            </span>
            <i className={`bi ${openMenu === "accounts" ? "bi-chevron-up" : "bi-chevron-down"}`}></i>
          </button>
          <div className={`sidebar-submenu ${menuClass("accounts")}`}>
            <Link to="/AccountMasterForm" className={`sidebar-sublink ${isActive("/AccountMasterForm") ? "active" : ""}`}>
              <i className="bi bi-journal-text"></i>
              Account Master
            </Link>
            <Link to="/BankEntryForm" className={`sidebar-sublink ${isActive("/BankEntryForm") ? "active" : ""}`}>
              <i className="bi bi-bank"></i>
              Bank Entry
            </Link>
            <Link to="/ExpenseForm" className={`sidebar-sublink ${isActive("/ExpenseForm") ? "active" : ""}`}>
              <i className="bi bi-cash-stack"></i>
              Expense Entry
            </Link>
            <Link to="/ExPDTReport" className={`sidebar-sublink ${isActive("/ExPDTReport") ? "active" : ""}`}>
              <i className="bi bi-file-text"></i>
              Expense Report
            </Link>
            <Link to="/DaybookReport" className={`sidebar-sublink ${isActive("/DaybookReport") ? "active" : ""}`}>
              <i className="bi bi-book"></i>
              DayBook Report
            </Link>
          </div>
        </div>
   )}

   
      
        {/* {hasAccess("Pharmacy") && (

        <div className="sidebar-section">
          <button
            className={`sidebar-dropdown-btn ${openMenu === "medicine" ? "active" : ""}`}
            onClick={() => toggleMenu("medicine")}
          >
            <span className="d-flex align-items-center">
              <div className="link-icon-box">
                <i className="bi bi-capsule-pill sidebar-icon"></i>
              </div>
              <span>Pharmacy</span>
            </span>
            <i className={`bi ${openMenu === "medicine" ? "bi-chevron-up" : "bi-chevron-down"}`}></i>
          </button>
          <div className={`sidebar-submenu ${menuClass("medicine")}`}>

           
               <Link to="/PharmacyDashboard" className={`sidebar-sublink ${isActive("/PharmacyDashboard") ? "active" : ""}`}>
              <i className="bi bi-grid-3x3"></i>
              Pharmacy Dashboard
            </Link> 

             <Link to="/DashboardReport" className={`sidebar-sublink ${isActive("/DashboardReport") ? "active" : ""}`}>
              <i className="bi bi-speedometer2"></i>
              Dashboard Report
            </Link>
            <Link to="/MedCategoryForm" className={`sidebar-sublink ${isActive("/MedCategoryForm") ? "active" : ""}`}>
              <i className="bi bi-grid-3x3"></i>
              Medicine Category
            </Link>
            <Link to="/MedBrandForm" className={`sidebar-sublink ${isActive("/MedBrandForm") ? "active" : ""}`}>
              <i className="bi bi-tag"></i>
              Medicine Brand
            </Link>
            <Link to="/MedicineForm" className={`sidebar-sublink ${isActive("/MedicineForm") ? "active" : ""}`}>
              <i className="bi bi-prescription2"></i>
              Medicine Form
            </Link>
            <Link to="/VendorForm" className={`sidebar-sublink ${isActive("/VendorForm") ? "active" : ""}`}>
              <i className="bi bi-person-lines-fill"></i>
              Vendor Entry
            </Link>
            <Link to="/VendorPaymentForm" className={`sidebar-sublink ${isActive("/VendorPaymentForm") ? "active" : ""}`}>
              <i className="bi bi-currency-rupee"></i>
              Vendor Payment
            </Link>

            <Link to="/MedPurchase" className={`sidebar-sublink ${isActive("/MedPurchase") ? "active" : ""}`}>
              <i className="bi bi-cart-plus"></i>
              Medicine Purchase
            </Link>
            <Link to="/MedicinePurchaseSearch" className={`sidebar-sublink ${isActive("/MedicinePurchaseSearch") ? "active" : ""}`}>
              <i className="bi bi-search"></i>
              Purchase Search
            </Link>
            <Link to="/MedicineSaleForm" className={`sidebar-sublink ${isActive("/MedicineSaleForm") ? "active" : ""}`}>
              <i className="bi bi-basket"></i>
              Medicine Sale
            </Link>
            <Link to="/MedicineSaleSearch" className={`sidebar-sublink ${isActive("/MedicineSaleSearch") ? "active" : ""}`}>
              <i className="bi bi-search"></i>
              Sale Search
            </Link>
            <Link to="/StockOutForm" className={`sidebar-sublink ${isActive("/StockOutForm") ? "active" : ""}`}>
              <i className="bi bi-box-arrow-right"></i>
              Stock Out
            </Link>
            <Link to="/StockOutSearch" className={`sidebar-sublink ${isActive("/StockOutSearch") ? "active" : ""}`}>
              <i className="bi bi-search"></i>
              Stock Out Search
            </Link>
            <Link to="/DebitVoucher" className={`sidebar-sublink ${isActive("/DebitVoucher") ? "active" : ""}`}>
              <i className="bi bi-arrow-return-left"></i>
              Debit Voucher
            </Link>
            <Link to="/DebitVoucherSearch" className={`sidebar-sublink ${isActive("/DebitVoucherSearch") ? "active" : ""}`}>
              <i className="bi bi-search"></i>
              Debit Voucher Search
            </Link>
            <Link to="/InventoryReports" className={`sidebar-sublink ${isActive("/InventoryReports") ? "active" : ""}`}>
              <i className="bi bi-box-seam"></i>
              Inventory Reports
            </Link>
              <Link to="/SalesReports" className={`sidebar-sublink ${isActive("/SalesReports") ? "active" : ""}`}>
              <i className="bi bi-graph-up-arrow"></i>
              Sales Reports
            </Link>
            <Link to="/PurchaseReports" className={`sidebar-sublink ${isActive("/PurchaseReports") ? "active" : ""}`}>
              <i className="bi bi-cart-check"></i>
              Purchase Reports
            </Link>
             <Link to="/ExpiryReports" className={`sidebar-sublink ${isActive("/ExpiryReports") ? "active" : ""}`}>
              <i className="bi bi-exclamation-triangle"></i>
              Expiry Reports
            </Link>

            <Link to="/FinancialReports" className={`sidebar-sublink ${isActive("/FinancialReports") ? "active" : ""}`}>
              <i className="bi bi-wallet2"></i>
              Financial Reports
            </Link> 

            
           
            

            
          </div>
        </div>
        )}  */}
      </div>

      {/* Logout Button (Fixed at bottom) */}
      <div className="sidebar-footer p-3 border-top border-light border-opacity-25">
        <button className="sidebar-logout-btn" onClick={onLogout}>
          <i className="bi bi-box-arrow-right sidebar-icon"></i>
          <span>Logout</span>
        </button>
      </div>

  <style jsx>{`




.sidebar-hub-btn {
  width: 100%;
  display: flex;
  align-items: center;
  padding: clamp(6px, 0.6vw, 8px) clamp(10px, 1vw, 12px);
  margin-bottom: clamp(2px, 0.25vw, 3px);
  border-radius: clamp(6px, 0.6vw, 8px);
  border: 1px solid rgba(245,158,11,.2);
  background: rgba(245,158,11,.07);
  color: rgba(255,255,255,.9);
  font-size: clamp(11px, 0.9vw, 12px);
  font-weight: 500;
  cursor: pointer;
  transition: all .3s ease;
  text-align: left;
}
.sidebar-hub-btn:hover {
  background: rgba(245,158,11,.18);
  border-color: rgba(245,158,11,.45);
  color: #fbbf24;
  transform: translateX(3px);
}
.sidebar-hub-btn.active {
  background: rgba(245,158,11,.22);
  border-color: rgba(245,158,11,.55);
  color: #fbbf24;
  box-shadow: 0 0 10px rgba(245,158,11,.18);
}










        /* ✅ MAIN THEME BACKGROUND (Solid Color - No Gradient) */
        .bg-gradient-primary {
          /* Fallback agar variable load na ho */
          background: #0088cc; 
          
          /* Dynamic Solid Color */
          background: var(--theme-color, #0088cc) !important;
          
          transition: background 0.3s ease;
        }

        /* User Avatar */
        .user-avatar-wrapper {
          position: relative;
        }

        .user-avatar {
          width: clamp(50px, 4vw, 60px);
          height: clamp(50px, 4vw, 60px);
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.15);
          backdrop-filter: blur(10px);
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          border: 3px solid rgba(255, 255, 255, 0.3);
          position: relative;
        }

        .user-avatar i {
          font-size: clamp(28px, 2.8vw, 35px);
        }

        .status-dot {
          position: absolute;
          bottom: 2px;
          right: 2px;
          width: 14px;
          height: 14px;
          background: #00d4aa;
          border-radius: 50%;
          border: 3px solid var(--theme-color, #0088cc); /* Border matches Sidebar BG */
          animation: pulse-dot 2s infinite;
        }

        @keyframes pulse-dot {
          0%, 100% { box-shadow: 0 0 0 0 rgba(0, 212, 170, 0.7); }
          50% { box-shadow: 0 0 0 6px rgba(0, 212, 170, 0); }
        }

        /* Scrollbar Styling */
        .sidebar-menu::-webkit-scrollbar {
          width: 6px;
        }

        .sidebar-menu::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
        }

        .sidebar-menu::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 10px;
        }

        .sidebar-menu::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.3);
        }


        .sidebar-menu {
          overflow-y: auto; /* Sirf upar-niche scroll hoga */
          overflow-x: hidden; /* Niche wala (horizontal) scrollbar band ho jayega */
        }
        /* Icon Box */
        .link-icon-box {
          width: clamp(26px, 2.2vw, 30px);
          height: clamp(26px, 2.2vw, 30px);
          border-radius: clamp(5px, 0.5vw, 6px);
          background: rgba(255, 255, 255, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: clamp(8px, 0.8vw, 10px);
          transition: all 0.3s ease;
        }

        /* Sidebar Links */
        .sidebar-link {
          display: flex;
          align-items: center;
          padding: clamp(6px, 0.6vw, 8px) clamp(10px, 1vw, 12px);
          margin-bottom: clamp(2px, 0.25vw, 3px);
          border-radius: clamp(6px, 0.6vw, 8px);
          color: rgba(255, 255, 255, 0.9);
          text-decoration: none;
          font-size: clamp(11px, 0.9vw, 12px);
          font-weight: 500;
          transition: all 0.3s ease;
          position: relative;
        }

        .sidebar-link::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 3px;
          background: #ffffff;
          transform: scaleY(0);
          transition: transform 0.3s ease;
          border-radius: 0 10px 10px 0;
        }

        .sidebar-link:hover {
          background: rgba(255, 255, 255, 0.15);
          color: #ffffff;
          transform: translateX(3px);
        }

        .sidebar-link:hover .link-icon-box {
          background: rgba(255, 255, 255, 0.2);
          transform: scale(1.1);
        }

        /* Active State */
        .sidebar-link.active {
          background: rgba(255, 255, 255, 0.2);
          color: #ffffff;
          box-shadow: 0 3px 12px rgba(0, 0, 0, 0.1);
        }

        .sidebar-link.active::before {
          transform: scaleY(1);
        }

        .sidebar-link.active .link-icon-box {
          background: rgba(255, 255, 255, 0.3);
        }

        .sidebar-icon {
          font-size: clamp(14px, 1.2vw, 16px);
        }

        /* Dropdown Buttons */
        .sidebar-section {
          margin-bottom: 4px;
        }

        .sidebar-dropdown-btn {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: clamp(6px, 0.6vw, 8px) clamp(10px, 1vw, 12px);
          border: none;
          border-radius: clamp(6px, 0.6vw, 8px);
          background: transparent;
          color: rgba(255, 255, 255, 0.9);
          font-size: clamp(11px, 0.9vw, 12px);
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .sidebar-dropdown-btn:hover {
          background: rgba(255, 255, 255, 0.1);
          color: #ffffff;
        }

        .sidebar-dropdown-btn:hover .link-icon-box {
          background: rgba(255, 255, 255, 0.2);
          transform: scale(1.1);
        }

        .sidebar-dropdown-btn.active {
          background: rgba(255, 255, 255, 0.15);
          color: #ffffff;
        }

        .sidebar-dropdown-btn.active .link-icon-box {
          background: rgba(255, 255, 255, 0.2);
        }

        /* Submenu */
        .sidebar-submenu {
          padding-left: 16px;
          margin-top: 4px;
          animation: slideDown 0.3s ease;
        }

        @keyframes slideDown {
          from { opacity: 0; max-height: 0; }
          to { opacity: 1; max-height: 2000px; }
        }

        .sidebar-sublink {
          display: flex;
          align-items: center;
          padding: clamp(5px, 0.5vw, 7px) clamp(10px, 1vw, 12px);
          margin-bottom: clamp(1px, 0.15vw, 2px);
          border-radius: clamp(4px, 0.4vw, 6px);
          color: rgba(255, 255, 255, 0.75);
          text-decoration: none;
          font-size: clamp(10px, 0.8vw, 11px);
          font-weight: 400;
          transition: all 0.3s ease;
          position: relative;
        }

        .sidebar-sublink i {
          font-size: clamp(11px, 1vw, 13px);
          margin-right: clamp(6px, 0.6vw, 8px);
          min-width: clamp(16px, 1.4vw, 18px);
          text-align: center;
          color: rgba(255, 255, 255, 0.6);
        }

        .sidebar-sublink:hover {
          background: rgba(255, 255, 255, 0.1);
          color: #ffffff;
          padding-left: 18px;
        }

        .sidebar-sublink:hover i {
          color: #ffffff;
        }

        .sidebar-sublink.active {
          background: rgba(255, 255, 255, 0.15);
          color: #ffffff;
          border-left: 3px solid #ffffff;
          padding-left: 14px;
        }

        .sidebar-sublink.active i {
          color: #ffffff;
        }

        /* Logout Button */
        .sidebar-logout-btn {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 12px 16px;
          gap: 10px;
          border: none;
          border-radius: 10px;
          background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
          color: #ffffff;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(231, 76, 60, 0.3);
        }

        .sidebar-logout-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(231, 76, 60, 0.5);
          background: linear-gradient(135deg, #c0392b 0%, #e74c3c 100%);
        }

        .sidebar-logout-btn:active {
          transform: translateY(0);
        }
      `}</style>
    </div>
  );
};

export default Sidebar;
